// (c) Dr.DOC GmbH 2022

/*
// import DrawConnection from 'F:/DrDoc.WebServer/web-src/draw-connection-line.js'
// DrawConnection.init(this.$el.parentElement, initEvents);
// DrawConnection.update();
// Linien/Connection Container Element setzen:
// DrawConnection.con_lineContainer = elemRoot;
// [data-con-to=<selector>]
// [data-con-color]
// [data-con-width]
// [data-con-title]

  <div class="col align-self-center">
	<div class="con-dd-db card m-3 bg-grey text-dark text-center" data-con-to=".con-dd-serv"
	  data-con-color="darkred">
	  <div class="card-header fs-3">Dr.DOC<br />Datenbank</div>
	  <div class="card-body p-1">
		<ul class="list-group list-group-flush">
		  <li class="list-group-item">An item</li>
		  <li class="list-group-item">A second item</li>
		</ul>
	  </div>
	</div>
  </div>

  <div class="col align-self-left">
	<div class="con-dd-serv card m-3 bg-grey text-dark text-center" data-con-to=".con-dd-db"
	  data-con-color="green">
	  <div class="card-header fs-3">Dr.DOC<br />Server</div>
	  <div class="card-body p-1">
		<ul class="list-group list-group-flush">
		  <li class="list-group-item">An item</li>
		  <li class="list-group-item">A second item</li>
		</ul>
	  </div>
	</div>
  </div>

  <div class="col align-self-right">
	<div class="con-dd-client card m-3 bg-grey text-dark text-center" data-con-to=".con-dd-serv"
	  data-con-color="grey">
	  <div class="card-header fs-3">Dr.DOC<br />Client</div>
	  <div class="card-body p-1">
		<ul class="list-group list-group-flush">
		  <li class="list-group-item">Xtra</li>
		  <li class="list-group-item">Tapi</li>
		  <li class="list-group-item">VB API</li>
		</ul>
	  </div>
	</div>
  </div>



  
	<div>
		<table class="table table-lg">
			<tr>
				<td data-con-to="#tc">1 A</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">1 B</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">1 C</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">1 D</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">1 E</td>
			</tr>
			<tr>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
			</tr>
			<tr>
				<td data-con-to="#tc">2 A</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td id="tc">CENTER</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">2 C</td>
			</tr>
			<tr>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td>&nbsp;<br>&nbsp;</td>
			</tr>
			<tr>
				<td data-con-to="#tc">3 A</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">3 B</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">3 C</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">3 D</td>
				<td>&nbsp;<br>&nbsp;</td>
				<td data-con-to="#tc">3 E</td>
			</tr>
		</table>
	</div>
*/

export default function DrawConnection() {

};
window.DrawConnection = DrawConnection;

DrawConnection.DefaultColor = 'rgba(64,64,64,0.8)'; // 'rgb(32,32,32)'; // 'black';
DrawConnection.DefaultWidth = 1;

/*
export default function DrawConnection()
{
	
};
*/


/*
data-con-to="d-main" data-con-color="darkblue" data-con-width="1"
*/

/*connect('d-1', 'd-main', 'darkgreen', 2);
connect('d-2', 'd-main', 'darkgreen', 2);

connect('d-3', 'd-main', 'darkblue', 2);
connect('d-4', 'd-main', 'darkred', 2);
connect('d-5', 'd-main', 'darkred', 2);*/

DrawConnection.con_getElem = function (el) {
	if (el != undefined && el != null)
		return el;
	return document;
}

DrawConnection.con_getOffset = function (el) {
	var rect = el.getBoundingClientRect();
	return {
		left: rect.left + window.pageXOffset,
		top: rect.top + window.pageYOffset,
		width: rect.width || el.offsetWidth,
		height: rect.height || el.offsetHeight
	};
};

DrawConnection.con_getLength = function (x1, y1, x2, y2) {
	return Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
};

DrawConnection.con_lineContainer = document.body;

DrawConnection.con_connectElements = function (div1, div2, color, thickness, title) {
	const off1 = DrawConnection.con_getOffset(div1);
	const off2 = DrawConnection.con_getOffset(div2);

	/*
	const x1 = off1.left + off1.width;
	const y1 = off1.top + off1.height;

	const x2 = off2.left + off2.width;
	const y2 = off2.top;
    
	const length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
	*/

	// --

	// Linie mit dem geringsten Abstanf finden

	let x1 = 0;
	let x2 = 0;
	let y1 = 0;
	let y2 = 0;

	let length = -1;

	//let f_y_arr = [0.5, 0.25, 0.15];
	//let f_y_arr = [0.5, 0.25, 0.75, 0.0, 1.0];
	//let f_y_arr = [0.0, 1.0, 0.5];
	//let f_x_arr = [0.0, 1.0, 0.5, 0.25, 0.75];
	let f_x_arr = [0.5, 0.0, 1.0, 0.2, 0.3, 0.4, 0.6, 0.7, 0.8];
	let f_y_arr = [0.5, 0.0, 1.0, 0.2, 0.3, 0.4, 0.6, 0.7, 0.8];

	for (let f_x1 of f_x_arr) {
		for (let f_x2 of f_x_arr) {
			for (let f_y1 of f_y_arr) {
				for (let f_y2 of f_y_arr) {
					/*if (off1.top == off2.top)
					{
					  f_y1 = 0.5;
					  f_y2 = 0.5;
					}
					if (off1.left == off2.left)
					{
					  f_x1 = 0.5;
					  f_x2 = 0.5;
					}*/

					// Prüfen: Punkte müssen am Rand sein und nicht im Element
					if (f_x1 > 0.0 && f_x1 < 1.0 && f_y1 > 0.0 && f_y1 < 1.0)
						continue;
					if (f_x2 > 0.0 && f_x2 < 1.0 && f_y2 > 0.0 && f_y2 < 1.0)
						continue;

					// Ecke vermeiden
					if ((f_x1 == 0.0 || f_x1 == 1.0) && (f_y1 == 0.0 || f_y1 == 1.0))
						continue;
					// Ecke vermeiden
					if ((f_x2 == 0.0 || f_x2 == 1.0) && (f_y2 == 0.0 || f_y2 == 1.0))
						continue;

					let tmp_x1 = off1.left + off1.width * f_x1;
					let tmp_y1 = off1.top + off1.height * f_y1;

					let tmp_x2 = off2.left + off2.width * f_x2;
					let tmp_y2 = off2.top + off2.height * f_y2;

					if (DrawConnection.con_lineContainer.offsetLeft) {
						tmp_x1 -= DrawConnection.con_lineContainer.offsetLeft;
						tmp_x2 -= DrawConnection.con_lineContainer.offsetLeft;
					}
					if (DrawConnection.con_lineContainer.scrollLeft) {
						tmp_x1 += DrawConnection.con_lineContainer.scrollLeft;
						tmp_x2 += DrawConnection.con_lineContainer.scrollLeft;
					}
					
					if (DrawConnection.con_lineContainer.offsetTop) {
						tmp_y1 -= DrawConnection.con_lineContainer.offsetTop;
						tmp_y2 -= DrawConnection.con_lineContainer.offsetTop;
					}
					if (DrawConnection.con_lineContainer.scrollTop) {
						tmp_y1 += DrawConnection.con_lineContainer.scrollTop;
						tmp_y2 += DrawConnection.con_lineContainer.scrollTop;
					}

					let m = Math.abs((y2 - y1) / (x2 - x1));
					if (isNaN(m) || m == Number.NaN || m == NaN)
						m = 0.0;
					//console.log(m);

					/*
					// Y oben/unten nur anwenden, wenn "to" deutlich darüber/darunter liegt (und nicht daneben liegt) = m hat große Steigung
					if (!((f_y1 >= 0.2 || f_y1 <= 0.8) && m >= 1.0))
						continue;
					if (!((f_y2 >= 0.2 || f_y2 <= 0.8) && m >= 1.0))
						continue;
						
					// X links/rechts nur anwenden, wenn "to" deutlich links/rechts daneben liegt (und nicht drüber/drunter)
					if (!((f_x1 >= 0.2 || f_x1 <= 0.8) && m <= 1.0))
						continue;
					if (!((f_x2 >= 0.2 || f_x2 <= 0.8) && m <= 1.0))
						continue;
*/
					/*
					// kleine Steigung + ganz open/unten => überspringen
					if (m < 0.5 && (f_y1 == 1.0 || f_y1 == 0.0))
						continue;
					// kleine Steigung + ganz open/unten => überspringen
					if (m < 0.5 && (f_y2 == 1.0 || f_y2 == 0.0))
						continue;

					// große Steigung + ganz links/rechts => überspringen
					if (m > 4.0 && (f_x1 == 1.0 || f_x1 == 0.0))
						continue;
					// große Steigung + ganz links/rechts => überspringen
					if (m > 4.0 && (f_x2 == 1.0 || f_x2 == 0.0))
						continue;
*/
					let tmp_length = DrawConnection.con_getLength(tmp_x1, tmp_y1, tmp_x2, tmp_y2);
					// das Ergebnis mit der geringsten Länge übernehmen
					if (length == -1 || (tmp_length < length && tmp_length > 0)) {
						x1 = tmp_x1;
						y1 = tmp_y1;
						x2 = tmp_x2;
						y2 = tmp_y2;

						length = tmp_length;
					}
				}
			}
		}
	}

	if (length < 0)
		return;

	// --

	//const curveSize = Math.max(Math.max(thickness + 2, 10), Math.min(150, Math.min(Math.abs(y1 - y2), Math.abs(x1 - x2)) / 3));
	const curveSize = Math.max(Math.max(thickness + 2, 10), Math.min(150, Math.min(Math.abs(y1 - y2), Math.abs(x1 - x2)) / 3));
	const arrowSizeRadius = Math.max(3, 1.5 * thickness);
	const height = Math.max(curveSize, 2 * arrowSizeRadius);

	const cx = ((x1 + x2) / 2) - (length / 2);
	const cy = ((y1 + y2) / 2) - (height / 2);

	const angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);

	if (cx < 0)
		return;
	if (cy < 0)
		return;

	// --

	const elemCanvas = document.createElement("canvas");
	elemCanvas.classList.add('line-connection-elem');
	elemCanvas.style.margin = '0px';
	elemCanvas.style.padding = '0px';
	elemCanvas.style.position = 'absolute';
	elemCanvas.style.left = cx + 'px';
	elemCanvas.style.top = cy + 'px';
	elemCanvas.style.width = length + 'px';
	elemCanvas.width = length;
	elemCanvas.style.height = (height) + 'px';
	elemCanvas.style.lineHeight = (height) + 'px';
	elemCanvas.height = height;
	elemCanvas.style.transform = `rotate(${angle}deg)`;
	elemCanvas.style.mozTransform = `rotate(${angle}deg)`;
	elemCanvas.style.webkitTransform = `rotate(${angle}deg)`;
	elemCanvas.style.pointerEvents = 'none';
	//elemCanvas.style.zIndex = -1;
	//elemCanvas.style.zIndex = 1000;

	const ctx = elemCanvas.getContext("2d");

	//let start = { x: cx, y: cy };
	let start = {
		x: arrowSizeRadius,
		y: height / 2
	};
	let end = {
		x: length - arrowSizeRadius,
		y: height / 2
	};
	let cp1 = {
		x: Math.max(thickness, length / 4),
		y: height / 2
	};
	let cp2 = {
		x: length - cp1.x,
		y: height / 2
	};

	let heightX = height / 4;

	// erst ab 5° "bezierCurveTo" mit abweichendem cp1.y und cp2.y
	const angleMargin = 5;

	//if ((angle < 0 && angle >= -45) || (angle > 45 && angle <= 90) || (angle < -90 && angle >= -135) || (angle > 135 && angle <= 180))
	if ((angle < 0 - angleMargin && angle >= -45) || (angle > 45 && angle < 90 - angleMargin) || (angle < -90 - angleMargin && angle >= -135) || (angle > 135 && angle < 180 - angleMargin)) {
		cp1.y = curveSize + heightX;
		cp2.y = 0 - heightX;
	}
	//if ((angle > 0 && angle <= 45) || (angle < -45 && angle >= -90) || (angle > 90 && angle <= 135) || (angle < -135 && angle >= -180))
	if ((angle > 0 + angleMargin && angle <= 45) || (angle < -45 && angle > -90 + angleMargin) || (angle > 90 + angleMargin && angle <= 135) || (angle < -135 && angle > -180 + angleMargin)) {
		cp2.y = 0 - heightX;
		cp2.y = curveSize + heightX;
	}

	ctx.fillStyle = color;
	ctx.strokeStyle = color;
	ctx.lineWidth = thickness;

	// Start Punkt
	ctx.beginPath();
	//ctx.arc(start.x + arrowSizeRadius, start.y, arrowSizeRadius, 0, 2 * Math.PI);
	ctx.arc(end.x, end.y, arrowSizeRadius, 0, 2 * Math.PI);
	ctx.fill();

	// Ziel Pfeil
	ctx.beginPath();
	//ctx.moveTo(end.x + arrowSizeRadius, end.y);
	//ctx.lineTo(end.x - arrowSizeRadius*1.5, end.y - arrowSizeRadius*1);
	//ctx.lineTo(end.x - arrowSizeRadius*1.5, end.y + arrowSizeRadius*1);
	ctx.moveTo(start.x - arrowSizeRadius, start.y);
	ctx.lineTo(start.x + arrowSizeRadius * 1.69, start.y - arrowSizeRadius * 1);
	ctx.lineTo(start.x + arrowSizeRadius * 1.69, start.y + arrowSizeRadius * 1);
	ctx.fill();

	// Cubic Bézier curve
	ctx.beginPath();
	ctx.moveTo(start.x, start.y);
	ctx.bezierCurveTo(cp1.x, cp1.y, cp2.x, cp2.y, end.x, end.y);
	ctx.stroke();

	if (title != undefined && title != null && title.length > 0) {
		//elemCanvas.setAttribute('data-bs-toggle', 'tooltip');
		//elemCanvas.setAttribute('data-bs-title', title);
		//elemCanvas.setAttribute('data-bs-placement', 'top');
		//elemCanvas.setAttribute('data-bs-offset',);
		//elemCanvas.setAttribute('title', title);
		let fontSize = Math.max(28, Math.min(80, height));
		ctx.font = `Segoe-UI light {fontSize}px serif`;
		ctx.textAlign = 'center';
		//ctx.textBaseline = 'middle';
		ctx.lineWidth = 1.5;
		ctx.fillStyle = 'black';
		ctx.strokeStyle = 'black';
		//ctx.strokeText(title, Math.max(15, length / 2 - (fontSize/5*title.length)/2), Math.max(2, height/2+fontSize/8));
		ctx.fillText(title, Math.max(15, length / 2 - (fontSize / 6 * title.length) / 2), Math.max(2, height / 2 + fontSize / 8), length);
	}

	DrawConnection.con_lineContainer.appendChild(elemCanvas);


	// Tooltips rendern
	if (window.bootstrap !== undefined) {
		//document.querySelectorAll('.line-connection-elem[data-bs-toggle="tooltip"]').forEach(function (triggerElem) {
		let triggerElem = elemCanvas;
		let title = triggerElem.getAttribute('data-bs-title');
		if (!DrDocWeb.IsNullOrEmpty(title)) {
			const bs_elem = window.bootstrap.Tooltip.getOrCreateInstance(triggerElem);
		}
		//bs_elem.update();
		//});
	}

	// --
	/*
		const cssStyle = `
		padding:0px;
		margin:0px;
		height:${thickness}px;
		background-color:${color};
		line-height:1px;
		position:absolute;
		left:${cx}px;
		top:${cy}px;
		width:${length}px;
		-moz-transform:rotate(${angle}deg);
		-webkit-transform:rotate(${angle}deg);
		-o-transform:rotate(${angle}deg);
		-ms-transform:rotate(${angle}deg);
		transform:rotate(${angle}deg);
		x-box-shadow: 0px 0px ${DrawConnection.DefaultWidth * 2}px rgba(0,0,0, 0.1);
		`;
	
		//const htmlLine = `<div class="line-connection-elem" style="${cssStyle}" />`;
	
		//DrawConnection.con_lineContainer.innerHTML += htmlLine.replaceAll("\r", "").replaceAll("\n", "");
		var elemDiv = document.createElement('div');
		elemDiv.classList.add('line-connection-elem');
		elemDiv.style.cssText = cssStyle;
		DrawConnection.con_lineContainer.appendChild(elemDiv);*/
}

DrawConnection._staticCounter = 1;
DrawConnection.con_reset = function (el) {
	let connectionElemList = DrawConnection.con_getElem(el).querySelectorAll('.line-connection-elem');
	if (connectionElemList != undefined && connectionElemList != null && connectionElemList.length > 0) {
		//console.log('Connection: removing nr of lines: ', connectionElemList.length, connectionElemList);
		connectionElemList.forEach(function (lineItm) {
			//lineItm.parentNode.removeChild(lineItm);
			lineItm.remove();
		});
		return true;
	}
	/*document.querySelectorAll('.line-connection-elem').forEach(function (lineItm) {
		lineItm.remove();
	});*/
	return false;
};
DrawConnection.con_getBoxElements = function (el) {
	var boxElements = DrawConnection.con_getElem(el).querySelectorAll('[data-con-to]');
	if (boxElements != undefined && boxElements != null && boxElements.length > 0)
		return boxElements;
	else
		return undefined;
};
DrawConnection.con_render = function (el) {

	// bisher gerenderte linien entfernen
	DrawConnection.con_reset(el);

	/*
	// alte Connection Classes entfernen
	for (let i = 1; i < 500; i++)
	{
		document.querySelectorAll('.con-id-' + i).forEach(function (itm) {
			if (itm.classList)
			{
				for (let className of itm.classList)
				{
					if (className.indexOf('con-id-') === 0)
					itm.classList.remove(className);
				}
			}
		});
	}*/

	// data-con-to="d-main" data-con-color="darkblue" data-con-width="1"
	// [data-con-to="*"]
	//document.querySelectorAll('div[data-con-to]').forEach(function(elemItem) { });
	var boxElements = DrawConnection.con_getBoxElements(el);
	if (boxElements == undefined)
		return;
	//for (var index = 0; index < boxElements.length; index++) {
	//	var elemItem = boxElements[index];
	boxElements.forEach((elemItem) => {

		if (elemItem.style.display == 'none') {
			console.log('DrawConnection.con_render: skip 1: ', elemItem);
			return;
		}

		if (elemItem._conInitialized === true) {
			// bereits initialisiert
		}
		else {
			// noch nicht initialisiert
			elemItem._conInitialized = true;
			// beim Click rendern
			elemItem.addEventListener('click', function (e) {
				//DrawConnection.update(e);
				setTimeout(function () {
					//DrawConnection.con_render(elemItem);
					DrawConnection.update(e);
				}, 50);
			});
		}

		//let id = elemItem.id;
		//let id = elemItem.getAttribute('id');
		let toSelector = elemItem.getAttribute('data-con-to');
		let color = elemItem.getAttribute('data-con-color');
		let width = elemItem.getAttribute('data-con-width');
		let title = elemItem.getAttribute('data-con-title');

		/*if (id == undefined || id == null || id == '') {
		//id = 'con-id-' + index;
		id = 'con-id-' + DrawConnection._staticCounter;
		DrawConnection._staticCounter++;
		//elemItem.setAttribute('id', id);
		//elemItem.id = id;
		elemItem.classList.add(id);
		console.log(elemItem);
		}*/

		let srcSelector = '';
		let id = elemItem.getAttribute('id');
		if (id != undefined && id != null && id != '') {
			srcSelector = '#' + id;
		}
		else {
			// wenn kein Selektor vorhanden ist, einen erstellen
			//if (elemItem._conInitName === undefined) {
			/*srcSelector = '.con-id-' + DrawConnection._staticCounter;
			DrawConnection._staticCounter++;
			elemItem._conInitName = srcSelector;
			elemItem.classList.add(srcSelector.substring(1));*/

			// immer über eindeutige ID steuern
			srcSelector = '#con-id-' + DrawConnection._staticCounter;
			elemItem.id = srcSelector.substring(1);
			//elemItem._conInitName = srcSelector;
			DrawConnection._staticCounter++;
			/*}
			else {
				srcSelector = elemItem._conInitName;
			}*/
		}

		if (color == null || color == undefined || color == '')
			color = DrawConnection.DefaultColor;

		//if (typeof width === 'string')
		//	width = +width;
		if (width == null || width == undefined || width == '' || width == '0' || +width <= 0)
			width = DrawConnection.DefaultWidth;

		if (toSelector != undefined && toSelector != null && toSelector != '') {
			var el_from = (typeof srcSelector === 'string' && srcSelector) ? DrawConnection.con_getElem(el).querySelectorAll(srcSelector) : elemItem;
			var el_to = DrawConnection.con_getElem(el).querySelectorAll(toSelector);

			if (el_from == null || el_from.length == 0 || el_to == null || el_to.length == 0) {
				//console.log('con_render, elem==null, : ', srcSelector, elemItem, toSelector);
			}
			else {
				//console.log('con_render, elem!=null: ', el_from, ' -> ', el_to);

				el_from.forEach((el_from_item) => {
					if (el_from_item.style.display == 'none') {
						console.log('DrawConnection.con_render: skip from: ', el_from_item);
						return;
					}

					el_to.forEach((el_to_item) => {
						if (el_to_item.style.display == 'none') {
							console.log('DrawConnection.con_render: skip to: ', el_to_item);
							return;
						}

						DrawConnection.con_connectElements(el_from_item, el_to_item, color, +width, title);
					});
				});
			}
		}
	});
};

DrawConnection.update = function (e) {
	DrawConnection.con_render(null);
};

DrawConnection.init = function (el, listener, lineContainerElem) {
	if (lineContainerElem != undefined && lineContainerElem != null) {
		DrawConnection.con_lineContainer = lineContainerElem;
		DrawConnection.con_lineContainer.style.position = 'relative';

		//console.log('con init container: X: ', DrawConnection.con_lineContainer.left, DrawConnection.con_lineContainer.offsetLeft);
		//console.log('con init container: Y: ', DrawConnection.con_lineContainer.top, DrawConnection.con_lineContainer.offsetTop);
	}
	else {
		DrawConnection.con_lineContainer = document.body;
	}

	// keine Elemente vorhanden!
	var boxElements = DrawConnection.con_getBoxElements(el);
	if (boxElements == undefined) {
		console.log('Connection: keine Elemente vorhanden!');
		return;
	}

	// wurde bereits initialisiert?
	if (DrawConnection.con_reset(el)) {
		console.log('Connection: wurde bereits initialisiert!');
		return;
	}

	//DrawConnection.con_render(null);
	DrawConnection.con_render(el);
	//window.addEventListener('resize', DrawConnection.con_render);
	//document.addEventListener('DOMContentLoaded', DrawConnection.con_render);

	if (listener == undefined || listener == true) {
		setTimeout(DrawConnection.update, 100);
		//setTimeout(DrawConnection.update, 2 * 1000);
		setInterval(DrawConnection.update, 6 * 1000);

		window.removeEventListener('resize', DrawConnection.update);
		window.addEventListener('resize', DrawConnection.update);

		document.removeEventListener('DOMContentLoaded', DrawConnection.update);
		document.addEventListener('DOMContentLoaded', DrawConnection.update);
	}
};
